import React from 'react';
import {Context} from '../../context';
import Section from '../UI/Section';
import {migration, fareCapping} from '../../settings';

import MyAccount from './MyAccount';
import BillingInformation from './BillingInformation';
import OrderHistory from './OrderHistory';
import MyTicketsAndPasses from './MyTicketsAndPasses';
import FareCapping from './FareCapping';
import AccountReport from './AccountReport';
import RecoverAccount from './RecoverAccount';

export default function MyAccountTopLevel(props) {
  const {localeText} = React.useContext(Context);

  const sectionIdInUrl = sectionId => window.location.hash.includes(sectionId);

  return (
    <Section
      sectionId='my-account'
      heading={localeText('rw_header_my_account', 'My Account')}
    >
      <MyAccount expanded={true} />
      <BillingInformation />
      <OrderHistory />
      <MyTicketsAndPasses
        expanded={() => sectionIdInUrl('tickets-and-passes')}
      />
      {fareCapping && <FareCapping />}
      <AccountReport />
      {migration && <RecoverAccount />}
    </Section>
  );
}
